import * as React from "react";
import { Formik, Form } from "formik";
import { Routine } from "redux-saga-routines";
import { Action, ActionFunctionAny } from "redux-actions";
import { hasDisplay } from "../tabDefinition";
import { SettingEnum } from "../settingEnum";
import { connect } from "react-redux";
import { fetchSoundLight, saveSoundLight } from "../Store/routines";
import { SoundLightSettings } from "../types";
import { injectIntl,  } from "react-intl";
import { SaveButton, CancelButton } from "../../DefaultSettings/Settings/styled";
import { ButtonContainer } from "../General/Tabs/styled";
import UnsavedCheck from "../../SaveNeeded/unsavedModal";
import { Layout } from "../LayoutEnum";
import { AppState } from "@Safemate/Store/types";
import {MiscSettingsWrapped} from "@Safemate/Settings";
import ValueSlider from "./Components/slider";
import {
  ConfigPage,
  ConfigPanel,
  PanelBody,
  Section,
  SectionHead,
  SectionTitle,
  SectionDesc,
  SectionBody,
  Item,
  Footer
} from "./styles";

export interface SoundLight extends MiscSettingsWrapped {
  settings: SoundLightSettings;
  fetchSettings: Routine<ActionFunctionAny<Action<any>>>;
  saveSoundLight: Routine<ActionFunctionAny<Action<any>>>;
  deviId: number;
  dehaId: number;
  layout: Layout;
}

const SoundLight = injectIntl(({ intl: { formatMessage }, settings, fetchSettings, saveSoundLight, deviId, dehaId, layout, components }: SoundLight) => {

  React.useEffect(() => {
    fetchSettings(deviId)
  }, [deviId])

  const display = hasDisplay.get(dehaId);
  const displayTitle = display
    ? formatMessage({ id: "display", defaultMessage: "Skjerm" })
    : formatMessage({ id: "light", defaultMessage: "Lys" });
  const displayDesc = display
    ? formatMessage({ id: "displaySettingsDesc", defaultMessage: "Juster lysstyrken på enhetens skjerm." })
    : formatMessage({ id: "lightSettingsDesc", defaultMessage: "Still inn lysindikatoren på enheten." });

  const soundTitle = formatMessage({ id: "sound", defaultMessage: "Lyd" });
  const soundDesc = formatMessage({ id: "soundSettingsDesc", defaultMessage: "Still inn volum og lyder for enheten." });

  const renderComponents = (setting: SettingEnum) =>
    components.get(setting)?.map((comp, index) => {
      const rendered = React.cloneElement(comp, { layout, key: index });
      if (comp.type === ValueSlider) {
        return rendered;
      }
      return <Item key={index}>{rendered}</Item>;
    });

  return (
    <Formik
      onSubmit={(values) => {
        saveSoundLight({
          deviceId: deviId,
          settings: values
        })
      }}
      enableReinitialize
      initialValues={settings}
    >
      {({dirty, setValues}) => (
        <ConfigPage>
          <ConfigPanel>
            <Form>
              <PanelBody>
                {components.has(SettingEnum.LIGHT) &&
                  <Section>
                    <SectionHead>
                      <SectionTitle>{displayTitle}</SectionTitle>
                      <SectionDesc>{displayDesc}</SectionDesc>
                    </SectionHead>
                    <SectionBody>
                      {renderComponents(SettingEnum.LIGHT)}
                    </SectionBody>
                  </Section>
                }
                {components.has(SettingEnum.SOUND) &&
                  <Section>
                    <SectionHead>
                      <SectionTitle>{soundTitle}</SectionTitle>
                      <SectionDesc>{soundDesc}</SectionDesc>
                    </SectionHead>
                    <SectionBody>
                      {renderComponents(SettingEnum.SOUND)}
                    </SectionBody>
                  </Section>
                }
              </PanelBody>
              <Footer>
                <ButtonContainer disabled={!dirty}>
                  <CancelButton disabled={!dirty} onClick={() => setValues(settings)}>
                    {formatMessage({id: "cancel", defaultMessage: "Avbryt"})}
                  </CancelButton>
                  <SaveButton disabled={!dirty} type="submit">
                    {formatMessage({id: "save", defaultMessage: "Lagre"})}
                  </SaveButton>
                </ButtonContainer>
              </Footer>
              <UnsavedCheck/>
            </Form>
          </ConfigPanel>
        </ConfigPage>
      )}
    </Formik>
  )
})

const mapStateToProps = ({ settings: {initialization: {layout}, soundLight: { settings }, initialization: {deviId}, device: { device: { dehaId } }}}: AppState) => {
  return {
    settings,
    deviId,
    dehaId,
    layout,
  }
}

const mapDispatchToProps = {
  fetchSettings: fetchSoundLight,
  saveSoundLight
};


export default connect(mapStateToProps, mapDispatchToProps)(SoundLight);
